/** Browser and WeCom client environment detection helpers. */

const MOBILE_PLATFORM_PATTERN = /iphone|ipod|ipad|android|windows phone|blackberry|mobile/i;

export function isWeComClient(userAgent: string = navigator.userAgent): boolean {
  return /wxwork|micromessenger|macwechat/i.test(userAgent);
}

export function isMobileDevice(userAgent: string = navigator.userAgent): boolean {
  const ua = userAgent.toLowerCase();
  if (isWeComClient(ua) && !MOBILE_PLATFORM_PATTERN.test(ua)) {
    return false;
  }
  return MOBILE_PLATFORM_PATTERN.test(ua);
}

export function isWeComDesktop(userAgent: string = navigator.userAgent): boolean {
  return isWeComClient(userAgent) && !MOBILE_PLATFORM_PATTERN.test(userAgent);
}

export function getWeComEntryPath(userAgent: string = navigator.userAgent): string {
  return isMobileDevice(userAgent) ? '/m' : '/';
}
